export async function rolesShowUseCase(role_id, roleRepository) {
    const result = await roleRepository.show(role_id);

    const role = await new roleRepository.model(result.data.success.arguments);

    if (!role.isValid()) {
        throw new Error("rol inválido");
    }

    return result;
}